import { ExportEmailDrawerTranslations } from "./export-email-drawer-pt-br";

export const EXPORT_EMAIL_DRAWER_FR_FR: ExportEmailDrawerTranslations = {
	title: "Exportations",
	description:
		"Veuillez entrer votre adresse e-mail pour recevoir le tableau. Nous vous enverrons le tableau dans quelques minutes et il sera également disponible dans 'Tableaux exportés' pendant 7 jours.",
	form: {
		label: "Email",
		placeholder: "Entrez votre email",
		required: "L'email est obligatoire",
		emailInvalid: "L'email est invalide",
		submit: "Exporter le tableau",
	},
};
